import { userRequest } from '@/sdk/oauth'
import logger from '@/sdk/logger'

export async function getAllContracts() {
  try {
    const { data } = await userRequest.get('customer/contract')

    return data
  } catch (error) {
    logger.error('failed fetching all contracts', {
      error,
      tags: ['contracts', 'http'],
    })

    throw error
  }
}

export async function getAllServicesRequests() {
  try {
    const { data } = await userRequest.get('customer/service-request')

    return data
  } catch (error) {
    logger.error('failed fetching all service requests', {
      error,
      tags: ['serviceRequests', 'http'],
    })

    throw error
  }
}

export async function rejectContract({ contractId, payload }): Promise<void> {
  try {
    return await userRequest.post(
      `/customer/contract/reject/${contractId}`,
      payload,
    )
  } catch (error) {
    logger.error('failed rejecting a contract', {
      error,
      tags: ['contracts', 'http'],
    })

    throw error
  }
}
